import {Component, forwardRef, HostListener} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'decimal-input',
    template: `
    <input class="form-control" type="text" [value]="value" (input)="onInput($event)" (blur)="onBlur()" />
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DecimalInputComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class DecimalInputComponent implements ControlValueAccessor {
  value: string = '';

  onChange = (value: number) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    if (value !== null && value !== undefined) {
      const parsed = parseFloat(value);
      if (!isNaN(parsed)) {
        this.value = this.formatValue(parsed);
      } else {
        this.value = this.formatValue(0);
      }
    } else {
      this.value = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInput(event: any): void {
    let inputValue = event.target.value;

    // Remove non-numeric except dot
    inputValue = inputValue.replace(/[^0-9.]/g, '');

    // Parse to float
    const parsed = parseFloat(inputValue);
    if (!isNaN(parsed)) {
      this.value = inputValue;
      this.onChange(parsed);
    } else {
      this.value = '';
      this.onChange(0);
    }
  }

  onBlur(): void {
    let parsed = parseFloat(this.value);
    if (isNaN(parsed)) {
      parsed = 0;
    }

    // Format to 2 decimal places
    this.value = this.formatValue(parsed);
    this.onChange(parsed);
    this.onTouched();
  }

  private formatValue(value: number): string {
    return value.toFixed(2);
  }
}
